import { useCallback } from 'react';
import { Alert, type AlertProps } from '@/shared/components/Alert';
import { DrawerBottomFixed, DrawerButton } from '@/shared/components/Drawer';

interface LoyaltyApplyErrorProps extends AlertProps {
    refresh: () => void;
}

export const LoyaltyApplyError = (props: LoyaltyApplyErrorProps) => {
    const refresh = useCallback(async () => {
        await props.refresh();
        props.onClose?.();
    }, [props]);

    return (
        <Alert
            {...props}
            title="Ошибка списания баллов"
            closable={false}
            button={
                <DrawerBottomFixed>
                    <DrawerButton onClick={refresh}>Обновить заказ</DrawerButton>
                </DrawerBottomFixed>
            }
        />
    );
};
